<div class="point-summary d-flex align-items-center justify-content-end text-end h-100 text-white gap-2">
  <span class="icons material-icons"> loyalty </span>

  <span class="fw-bold font-size-14 pe-2">{{ pointsBalance$ | async }}</span>
</div>
